import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var WebSvg = function WebSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.249a10 10 0 1 0 0 20 10 10 0 0 0 0-20m-.677 1.422a8.6 8.6 0 0 1 1.354 0l2.758 7.88h-6.87zm-1.574.273a8.6 8.6 0 0 0-6.325 7.607h3.662zm-2.663 9.003H3.424a8.605 8.605 0 0 0 6.325 7.607zm4.237 7.88a8.6 8.6 0 0 0 1.354 0l2.758-7.88h-6.87zm5.59-9.276-2.662-7.607a8.605 8.605 0 0 1 6.325 7.607zm0 1.396-2.662 7.607a8.6 8.6 0 0 0 6.325-7.607z",
    clipRule: "evenodd"
  }));
};
export var Web = function Web(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: WebSvg
  }));
};